const PredictSystemTypeId = `query PredictSystemTypeId($name: String!, $make: String!, $model: String!, $isChildEquipment: Boolean!){
    predictSystemTypeId(name:$name, make:$make, model:$model, isChildEquipment:$isChildEquipment) {
        system_type_id
    }
}`
export default PredictSystemTypeId;